import styled from 'styled-components/macro'

export const ButtonLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
